const buildConfig = (keyword, ext = {}) => {
  return {
    label: keyword, // 需要提示的关键字
    kind: 18, // 对应monaco.languages.CompletionItemKind.Text
    insertText: `${keyword}`, // 确认后输入的内容
    ...ext
  }
}

/**
 * 循环体内内建函数
 * 数据来源：http://freemarker.foofun.cn/ref_builtins_loop_var.html
 * @author Caesar Liu
 * @date 2020-11-20 14:58
 */
module.exports = [
  buildConfig('counter', {
    documentation: [
      '在循环体内进行计数，从1开始',
      'e.g: ',
      '<#list ["a", "b", "c"] as i>',
      '  ${i?counter}: ${i}',
      '</#list>',
      '结果输出',
      '  1: a',
      '  2: b',
      '  3: c'
    ].join('\n')
  }),
  buildConfig('has_next', {
    documentation: [
      '判断循环项是否是当前迭代的最后一项',
      'e.g: ',
      '<#list ["a", "b", "c"] as i>${i?has_next?c} </#list>',
      '结果输出',
      'true true false '
    ].join('\n')
  }),
  buildConfig('index', {
    documentation: [
      '返回当前循环项的索引',
      'e.g: ',
      '<#list ["a", "b", "c"] as i>',
      '  ${i?index}: ${i}',
      '</#list>',
      '结果输出',
      '  0: a',
      '  1: b',
      '  2: c'
    ].join('\n')
  }),
  buildConfig('is_even_item', {
    documentation: [
      '判断循环项的索引是否为奇数',
      'e.g: ',
      '<#list ["a", "b", "c"] as i>${i?is_even_item?c} </#list>',
      '结果输出',
      'false true false'
    ].join('\n')
  }),
  buildConfig('is_odd_item', {
    documentation: [
      '判断循环项的索引是否为偶数',
      'e.g: ',
      '<#list ["a", "b", "c"] as i>${i?is_odd_item?c} </#list>',
      '结果输出',
      'true false true '
    ].join('\n')
  }),
  buildConfig('is_first', {
    documentation: [
      '判断循环项是否为首个循环项',
      'e.g: ',
      '<#list ["a", "b", "c"] as i>${i?is_first?c} </#list>',
      '结果输出',
      'true false false'
    ].join('\n')
  }),
  buildConfig('is_last', {
    documentation: [
      '判断循环项是否为最后一个循环项',
      'e.g: ',
      '<#list ["a", "b", "c"] as i>${i?is_last?c} </#list>',
      '结果输出',
      'false false true'
    ].join('\n')
  }),
  buildConfig('item_cycle', {
    documentation: [
      '在循环过程中指定周期字符来循环获取',
      'e.g: ',
      '<#list ["a", "b", "c"] as i>',
      '  <tr class="${i?item_cycle("row1", "row2")}">${i}</tr>',
      '</#list>',
      '结果输出',
      '  <tr class="row1">a</tr>',
      '  <tr class="row2">b</tr>',
      '  <tr class="row1">c</tr>'
    ].join('\n')
  }),
  buildConfig('item_parity', {
    documentation: [
      '获取当前循环项索引的奇偶类型，返回"odd"或"even"',
      'e.g: ',
      '<#list ["a", "b", "c"] as i>',
      '  <tr class="${i?item_parity}Row">${i}</tr>',
      '</#list>',
      '结果输出',
      '  <tr class="oddRow">a</tr>',
      '  <tr class="evenRow">b</tr>',
      '  <tr class="oddRow">c</tr>'
    ].join('\n')
  }),
  buildConfig('item_parity_cap', {
    documentation: [
      '获取当前循环项索引的奇偶类型，返回"Odd"或"Even"',
      'e.g: ',
      '<#list ["a", "b", "c"] as i>',
      '  <tr class="row${i?item_parity_cap}">${i}</tr>',
      '</#list>',
      '结果输出',
      '  <tr class="rowOdd">a</tr>',
      '  <tr class="rowEven">b</tr>',
      '  <tr class="rowOdd">c</tr>'
    ].join('\n')
  })
]
